import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'textAlpha2Hover',
  $names: {
    target: '[data-js-hover=textAlpha2]',
    text: '.career_faq_panel_ttl_txt',
  },
  styleInfo: {
    alphaMouseEnter: 0.5,
    alphaMouseLeave: 1.0,
  },
}

export default class TextAlpha2Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      const $text = $target.querySelector(this.$names.text)
      if ($text) {
        gsap.killTweensOf($text, 'opacity')
        gsap.to($text, {
          opacity: this.styleInfo.alphaMouseEnter,
          duration: 0.5,
          ease: 'expo.out',
        })
      }
      gsap.delayedCall(0.4, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $text = $target.querySelector(this.$names.text)
      if ($text) {
        gsap.killTweensOf($text, 'opacity')
        gsap.to($text, {
          opacity: this.styleInfo.alphaMouseLeave,
          duration: 0.6,
          ease: 'none',
          delay: 0.05,
        })
      }

      resolve()
    })
  }
}